import * as yup from "yup";

const passwordRules = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{5,}$/;
// min 5 characters, 1 upper case letter, 1 lower case letter, 1 numeric digit.

// Kenyan mobile numbers: 07xxxxxxxx / 01xxxxxxxx (local)
//                     or +2547xxxxxxxx / 2547xxxxxxxx (international)
//                     or +2541xxxxxxxx / 2541xxxxxxxx
const kenyanPhoneRegExp = /^(\+?254|0)[17]\d{8}$/;
const kenyanPhoneMessage = 'Please enter a valid Kenyan phone number (e.g. 0712345678 or 0112345678)';



export const advancedSchema = yup.object().shape({
  username: yup
    .string()
    .min(3, "Username must be at least 3 characters long")
    .required("Required"),
  jobType: yup
    .string()
    .oneOf(["designer", "developer", "manager", "other"], "Invalid Job Type")
    .required("Required"),
  acceptedTos: yup
    .boolean()
    .oneOf([true], "Please accept the terms of service"),
});



// Basic schema for payment form validation
export const basicSchema = yup.object().shape({
  amount: yup
      .number()
      .positive('Amount must be positive')
      .required('Amount is required'),
  phone_number: yup
      .string()
      .matches(kenyanPhoneRegExp, kenyanPhoneMessage)
      .required('Phone number is required'),
});

// Date schema for vacating notice form validation
export const dateSchema = yup.object().shape({
  first_name: yup
      .string()
      .required('First name is required'),
  last_name: yup
      .string()
      .required('Last name is required'),
  phone_number: yup
      .string()
      .matches(kenyanPhoneRegExp, kenyanPhoneMessage)
      .required('Phone number is required'),
  national_id: yup
      .string()
      .required('National ID is required'),
  unit: yup
      .string()
      .required('House number is required'),
  // These fields are optional as they would be filled programmatically
  date_notice_given: yup
      .date()
      .nullable(),
  date_to_vacate_house: yup
      .date()
      .nullable(),
  reasons_for_vacating: yup
      .string()
      .nullable(),
});

// Additional schema for profile updates if needed
export const profileSchema = yup.object().shape({
  email_address: yup
      .string()
      .email('Please enter a valid email')
      .required('Email is required'),
  phone_number: yup
      .string()
      .matches(kenyanPhoneRegExp, kenyanPhoneMessage)
      .required('Phone number is required'),
});

// Schema for tenant creation if needed in other components
export const tenantSchema = yup.object().shape({
  first_name: yup
      .string()
      .min(2, 'First name must be at least 2 characters')
      .required('First name is required'),
  last_name: yup
      .string()
      .min(2, 'Last name must be at least 2 characters')
      .required('Last name is required'),
  national_id: yup
      .string()
      .min(6, 'Please enter a valid ID number')
      .required('National ID is required'),
  phone_number: yup
      .string()
      .matches(kenyanPhoneRegExp, kenyanPhoneMessage)
      .required('Phone number is required'),
  email_address: yup
      .string()
      .email('Please enter a valid email')
      .required('Email is required'),
  house_number: yup
      .string()
      .required('House number is required'),
  rent: yup
      .number()
      .positive('Rent must be positive')
      .required('Rent is required'),
});